export default "__VITE_ASSET__C3QlejwO__"